export var Role;
(function (Role) {
    Role["ORG_ADMIN"] = "org_admin";
    Role["CENTRAL_ENGINEER"] = "central_engineer";
    Role["LOCAL_ENGINEER"] = "local_engineer";
    Role["TEAM_LEADER"] = "team_leader";
    Role["OPERATOR"] = "operator";
    Role["CLIENT_VIEWER"] = "client_viewer";
})(Role || (Role = {}));
